var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAddPhoto48Line = function SvgIconAddPhoto48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.95 28.2-1.2-1.8a2.814 2.814 0 0 0-4.68 0l-1.6 2.4c-.58.86-.63 1.97-.14 2.88a2.81 2.81 0 0 0 2.47 1.48h12.55c1 0 1.91-.52 2.42-1.38.51-.86.52-1.91.03-2.79l-2.62-4.72a2.91 2.91 0 0 0-5.08 0l-2.18 3.93h.03ZM36.7 11.3V5.93h-3.4v5.37h-5.37v3.4h5.37v5.37h3.4V14.7h5.37v-3.4H36.7Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 33.4a1.9 1.9 0 0 1-1.9 1.9H14.6a1.9 1.9 0 0 1-1.9-1.9V16.6c0-1.05.85-1.9 1.9-1.9h9.63v-3.4H14.6a5.31 5.31 0 0 0-5.3 5.3v16.8c0 2.92 2.38 5.3 5.3 5.3h16.8c2.92 0 5.3-2.38 5.3-5.3v-9.63h-3.4v9.63Z",
    fill: "current"
  })));
};
export default SvgIconAddPhoto48Line;